<template>
  <div>
    <v-dialog
      v-model="show"
      width="480px"
      persistent
      scrollable
      :fullscreen="$vuetify.breakpoint.xsOnly"
    >
      <v-card style="border-radius: 0px !important">
        <v-card-title
          style="background: #2d8cff; text-color: #ffffff"
          class="d-flex"
          v-if="!submitSuccess"
        >
          <div class="titleText">Report & Block</div>
          <v-spacer></v-spacer>
          <v-btn
            text
            style="min-width: 0px; padding: 0 10px"
            @click="toggleBlockUser({ show: false })"
          >
            <v-icon color="#ffffff">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-title
          style="background: #219653; text-color: #ffffff"
          class="d-flex"
          v-else
        >
          <div class="titleText text-center pl-8" style="width: 85%">
            Successfully Reported!
          </div>
          <!-- <v-spacer></v-spacer> -->
          <v-btn
            text
            style="min-width: 0px; padding: 0 10px"
            @click="closeAndRedirect"
          >
            <v-icon color="#ffffff">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pt-8 px-0">
          <div class="text-center" v-if="loading" style="min-height: 500px">
            <v-progress-circular
              :size="100"
              :width="10"
              color="#2d8cff"
              indeterminate
              style="
                text-align: center;
                padding-top: 20px;
                padding-bottom: 20px;
                margin-top: 200px;
              "
            ></v-progress-circular>
          </div>
          <v-row v-else>
            <v-col cols="12" class="px-8">
              <div>
                <div class="textHealing py-2">
                  Why are you reporting
                  <span v-if="profile_object">this person</span>?
                </div>
                <div class="textParagraph">
                  Your report is anonymous, reason will be safe with us and
                  won't be shared.
                </div>
              </div>
            </v-col>
            <v-col cols="12" class="px-8">
              <div class="d-flex justify-center py-6" v-if="profile_object">
                <div class="profileDetailClass d-flex">
                  <div>
                    <v-avatar size="44" color="#2d8cff">
                      <span
                        v-if="!profile_object.profile_image"
                        class="avatarInitial"
                        v-text="getInitials(profile_object.name)"
                      ></span>
                      <img
                        v-else
                        :src="profile_object.profile_image"
                        alt="Profile Picture"
                      />
                    </v-avatar>
                  </div>
                  <div class="profileName pl-3 py-3">
                    {{ profile_object.name }}
                  </div>
                </div>
              </div>
            </v-col>
            <v-col cols="12" class="px-4">
              <div class="infoClass py-4 d-flex justify-center">
                Select reason
              </div>
              <div>
                <v-list>
                  <v-list-item
                    style="border-bottom: 0.5px solid rgba(51, 51, 51, 0.74)"
                    v-for="(item, i) in reasonList"
                    :key="i"
                  >
                    <v-btn
                      text
                      width="100%"
                      class="text-capitalize"
                      :loading="item.loading"
                      @click="submitForm(i, item.id)"
                    >
                      <span class="reasonText">{{ item.reason }}</span>
                      <v-spacer></v-spacer>
                      <v-list-item-icon>
                        <v-icon color="rgba(51, 51, 51, 0.74)" right size="28"
                          >mdi-chevron-right</v-icon
                        >
                      </v-list-item-icon>
                    </v-btn>
                  </v-list-item>
                </v-list>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <success-modal @close="submitSuccess = true"></success-modal>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import Axios from "@/api/BaseAxios.js";
export default {
  name: "ReportAndBlockUser",
  // props: ["profile_object", "loggedInProfile"],
  components: {
    SuccessModal: () => import("./SuccessModal/SuccessModal"),
  },
  data() {
    return {
      loading: false,
      submitSuccess: false,
      formLoading: false,
      reasonList: [],
      profile_object: null,
    };
  },
  computed: {
    ...mapGetters({
      getShowBlockUser: "blockUser/getShow",
    }),
    show: {
      get() {
        return this.getShowBlockUser;
      },
      set(value) {
        return this.toggleBlockUser({ show: value });
      },
    },
  },
  watch: {
    show(value) {
      if (value) {
        this.openModal();
      } else {
        this.closeModal();
      }
    },
  },
  methods: {
    ...mapActions({
      toggleBlockUser: "blockUser/toggleModal",
      toggleSuccessUser: "blockUser/toggleSuccessModal",
      snackBar: "snackBar/showSnack",
    }),
    openModal() {
      // console.log(this.loggedInProfile);
      this.profile_object =
        this.$store.state.blockUser.showModal.profile_object;
      this.getReasonList();
    },
    closeModal() {
      this.loading= false
      this.submitSuccess= false
      this.formLoading= false
      this.reasonList= []
      this.profile_object= null
    },
    closeAndRedirect() {
      this.toggleBlockUser({ show: false });
      if (this.submitSuccess) {
        let user_id = localStorage.getItem("user_id");
        if (this.$route.name === "HomePage") {
          window.location.reload();
        } else {
          this.$router.push(`/home/${user_id}`);
        }
      }
    },
    getInitials(name) {
      if (name) {
        let na = name.split(" ");
        let initial;
        if (na.length < 2) {
          initial = na[0].charAt(0) + na[0].charAt(1);
        } else {
          initial = na[0].charAt(0) + na[1].charAt(0);
        }
        return initial;
      } else {
        return "";
      }
    },
    getReasonList() {
      this.loading = true;
      const successHandler = (res) => {
        this.reasonList = res.data;
        this.loading = false;
      };
      const failureHandler = () => {
        this.loading = false;
      };
      let formData = {};
      Axios.request_GET(
        "master/reason_list/",
        formData,
        {},
        successHandler,
        failureHandler,
        false,
        false
      );
    },
    submitForm(index, reason) {
      console.log(reason);
      if (!this.submitSuccess) {
        this.reasonList[index].loading = true;
        const successHandler = (res) => {
          console.log(res);
          this.toggleSuccessUser({ show: true });
          setTimeout(() => {
            this.reasonList[index].loading = false;
          }, 500);
        };
        const failureHandler = () => {
          this.reasonList[index].loading = false;
        };
        let formData = {};
        formData["block_reason"] = reason;
        formData["blocked_profile"] = this.$store.state.blockUser.showModal.block_to;
        formData["blocked_by"] = this.$store.state.blockUser.showModal.block_by;
        Axios.request_POST(
          "api/report-and-block/",
          formData,
          {},
          successHandler,
          failureHandler,
          false,
          true
        );
      } else {
        this.snackBar({
          text: "You have already reported this user",
          color: "warning",
          timeout: 4500,
        });
      }
    },
  },
  mounted() {},
};
</script>
<style scoped>
.titleText {
  font-family: "Avenir";
  font-style: normal;
  font-weight: 800;
  font-size: 20px;
  line-height: 24px;
  /* identical to box height */

  color: #ffffff;
}
.avatarInitial {
  font-family: "Avenir";
  font-style: normal;
  font-weight: 800;
  font-size: 20px;
  line-height: 24px;

  color: #ffffff;
}
.profileName {
  font-family: "Avenir";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;

  color: #333333;
}
.textHealing {
  font-family: "Avenir";
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 22px;
  /* identical to box height */

  color: #333333;
}
.textParagraph {
  font-family: "Avenir";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;

  color: rgba(51, 51, 51, 0.74);
}
.infoClass {
  background: rgba(45, 140, 255, 0.1);
  border-width: 0.5px 0px;
  border-style: solid;
  border-color: #2d8cff;
  font-family: "Avenir";
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 22px;
  /* identical to box height */

  text-align: center;

  color: #2d8cff;
}
.reasonText {
  font-family: "Avenir";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;

  color: #333333;
}
</style>
